import moment from 'moment';
import axiosInstance, { axiosInstanceCached } from '@/utils/axios';
// import Configuration from '@/utils/configuration';
import { handleApiError } from '@/utils/helpers';

//* list all seasons
export const list = async () => {
  let response = {};

  try {
    response = await axiosInstance.get(`/seasons/all`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Get season list user has participated in
export const listUserSeasons = async ({ id, timeline }) => {
  let response = {};
  let totalSeasons = 0;

  try {
    response = await axiosInstance.get(`/seasons/user/${id}`);

    if (response.data === null) {
      response.data = [];
    }

    totalSeasons = response.data ? response.data.length : 0;

    if (response.data !== null && response.data !== '') {
      switch (timeline) {
        case 'past':
          response.data = response.data.filter((season) => {
            return (
              season.startsAt === null ||
              season.startsAt === undefined ||
              moment(season.endsAt).isBefore(moment())
            );
          });
          break;
        case 'present':
          response.data = response.data.filter((season) => {
            return (
              season.startsAt === null ||
              season.startsAt === undefined ||
              (moment(season.startsAt).isBefore(moment()) &&
                moment(season.endsAt).isAfter(moment()))
            );
          });
          break;
        case 'future':
          response.data = response.data.filter((season) => {
            return (
              season.startsAt === null ||
              season.startsAt === undefined ||
              moment(season.startsAt).isAfter(moment())
            );
          });
          break;
        case 'all':
          response.data = response.data;
          break;
        default:
          break;
      }
    }
    response.totalSeasons = totalSeasons;

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Get season list for a clubhouse
export const listClubhouseSeasons = async ({ id, timeline }) => {
  let response = {};
  let totalSeasons = 0;

  try {
    response = await axiosInstance.get(`/seasons/clubhouse/${id}`);
    totalSeasons = response.data ? response.data.length : 0;

    if (response.data !== null && response.data !== '') {
      switch (timeline) {
        case 'past':
          response.data = response.data.filter((season) => {
            return (
              season.startsAt === null ||
              season.startsAt === undefined ||
              season.endsAt === null ||
              season.endsAt === undefined ||
              moment(season.endsAt).isBefore(moment())
            );
          });
          break;
        case 'present':
          response.data = response.data.filter((season) => {
            return (
              season.startsAt === null ||
              season.startsAt === undefined ||
              season.endsAt === null ||
              season.endsAt === undefined ||
              (moment(season.startsAt).isBefore(moment()) &&
                moment(season.endsAt).isAfter(moment()))
            );
          });
          break;
        case 'future':
          response.data = response.data.filter((season) => {
            return (
              season.startsAt === null ||
              season.startsAt === undefined ||
              season.endsAt === null ||
              season.endsAt === undefined ||
              moment(season.startsAt).isAfter(moment())
            );
          });
          break;
        case 'all':
          response.data = response.data;
          break;
        default:
          break;
      }
    }
    response.totalSeasons = totalSeasons;

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Create a season
export const create = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.post(`/season`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Update a season
export const update = async (payload) => {
  let response = {};
  const { id } = payload;

  try {
    response = await axiosInstance.patch(`/season/${id}`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Show season details
export const show = async (id) => {
  let response = {};

  try {
    response = await axiosInstance.get(`/season/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Delete a season
export const deleteSeason = async ({ id }) => {
  let response = {};

  try {
    response = await axiosInstance.delete(`/season/${id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Add event to a season
export const addSeasonEvent = async (payload) => {
  let response = {};
  const { id } = payload;

  try {
    response = await axiosInstance.post(`/season/${id}/event`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Delete a season event
export const deleteSeasonEvent = async (payload) => {
  let response = {};
  const { id } = payload;

  try {
    response = await axiosInstance.delete(`/season/${id}/event`, {
      data: payload,
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Get season leaderboard
export const leaderboard = async (id) => {
  let response = {};
  let participants = 0;

  try {
    response = await axiosInstance.get(`/season/${id}/leaderboard`);
    participants = response.data ? response.data.length : 0;
    response.participants = participants;
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
